import React, { useState } from "react";
import { Link } from "react-router-dom";
import { requestPasswordReset } from "../api/client";
import BackgroundAnimation from "../components/BackgroundAnimation";
import "../auth.css";

export default function ForgotPassword() {
  const [email, setEmail]     = useState("");
  const [error, setError]     = useState("");
  const [info, setInfo]       = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!email) { setError("Email field is required"); return; }
    setLoading(true); setError(""); setInfo("");
    try {
      const data = await requestPasswordReset({ email });
      setInfo(data.message || "A recovery password reset link has been sent to your email.");
    } catch (err) {
      setError(err.response?.data?.detail || "Failed to send reset link.");
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-page">
      <BackgroundAnimation />
      <div className="auth-card">
        <div className="auth-brand">
          PINE<span className="accent">CONNECTOR</span>
        </div>
        <div className="auth-title">
          Recover Password
        </div>
        <div className="auth-sub">
          Enter your registered email to receive a password reset link
        </div>

        {error && (
          <div className="auth-error">{error}</div>
        )}
        
        {info && (
          <div className="auth-info" style={{ color: "var(--green)", background: "rgba(16, 185, 129, 0.08)", border: "1px solid rgba(16, 185, 129, 0.2)", padding: "10px", borderRadius: "var(--radius)", fontSize: "13px", marginBottom: "16px", fontWeight: "500", textAlign: "center" }}>
            {info}
          </div>
        )}

        <div className="form-group">
          <label className="form-label">Email Address</label>
          <input
            type="email"
            className="form-input"
            placeholder="you@example.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            onKeyDown={e => e.key === "Enter" && handleSubmit()}
          />
        </div>

        <button
          className="btn btn-primary"
          style={{ width: "100%", marginTop: 8 }}
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Sending link..." : "Send Reset Link"}
        </button>

        <div className="auth-footer" style={{ marginTop: "24px" }}>
          Remember your password?{" "}
          <Link to="/login">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
